import { render, staticRenderFns } from "./DetailLabel.vue?vue&type=template&id=70610538&"
import script from "./DetailLabel.vue?vue&type=script&lang=js&"
export * from "./DetailLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports